module.exports = __webpack_public_path__ + "static/media/step3-top.9bca2841.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step3-top.png
// module id = 3736
// module chunks = 0